// JavaScript Document

var wrapper    = $("#site-wrapper"),
    menu       = $(".menu"),
    toggle     = $(".nav-toggle"),
    toggleIcon = $(".nav-toggle span"),
	menu2       = $(".menu2"),
    toggle2     = $(".nav-toggle2"),
    toggleIcon2 = $(".nav-toggle2 span");
	menu3       = $(".menu3"),
    toggle3     = $(".nav-toggle3"),
    toggleIcon3 = $(".nav-toggle3 span");
	menu4       = $(".menu4"),
    toggle4     = $(".nav-toggle4"),
    toggleIcon4 = $(".nav-toggle4 span");

function toggleThatNav() {
  if (menu.hasClass("show-nav")) {
    if (!Modernizr.csstransforms) {
      menu.removeClass("show-nav");
      toggle.removeClass("show-nav");
      menu.animate({
        left: "-=300"
      }, 1000);
      toggle.animate({
        left: "-=-300"
      }, 1000);
    } else {
      menu.removeClass("show-nav");
      toggle.removeClass("show-nav");
    }
    
  } else {
    if (!Modernizr.csstransforms) {
      menu.addClass("show-nav");
      toggle.addClass("show-nav");
      menu.css("left", "-330px");
      toggle.css("left", "-330px");
    } else {
      menu.addClass("show-nav");
      toggle.addClass("show-nav");
    } 
  }
}

function toggleThatNav2() {
  if (menu2.hasClass("show-nav")) {
    if (!Modernizr.csstransforms) {
      menu2.removeClass("show-nav");
      toggle2.removeClass("show-nav");
      menu2.animate({
        left: "-=300"
      }, 1000);
      toggle2.animate({
        left: "-=-300"
      }, 1000);
    } else {
      menu2.removeClass("show-nav");
      toggle2.removeClass("show-nav");
	  menu.removeClass("show-nav");
	  toggle.removeClass("show-nav");
    }
    
  } else {
    if (!Modernizr.csstransforms) {
      menu2.addClass("show-nav");
      toggle2.addClass("show-nav");
      menu2.css("left", "-330px");
      toggle2.css("left", "-330px");
    } else {
	  
	  //menu.removeClass("show-nav");
	  //toggle.removeClass("show-nav");
      menu2.addClass("show-nav");
      toggle2.addClass("show-nav");
    } 
  }
}
function toggleThatNav3() {
  if (menu3.hasClass("show-nav")) {
    if (!Modernizr.csstransforms) {
      menu3.removeClass("show-nav");
      toggle3.removeClass("show-nav");
      menu3.animate({
        left: "-=300"
      }, 1000);
      toggle3.animate({
        left: "-=-300"
      }, 1000);
    } else {
      menu3.removeClass("show-nav");
      toggle3.removeClass("show-nav");
	  menu.removeClass("show-nav");
	  toggle.removeClass("show-nav");
    }
    
  } else {
    if (!Modernizr.csstransforms) {
      menu3.addClass("show-nav");
      toggle3.addClass("show-nav");
      menu3.css("left", "-330px");
      toggle3.css("left", "-330px");
    } else {
	  
	  //menu.removeClass("show-nav");
	  //toggle.removeClass("show-nav");
      menu3.addClass("show-nav");
      toggle3.addClass("show-nav");
    } 
  }
}
function toggleThatNav4() {
  if (menu4.hasClass("show-nav")) {
    if (!Modernizr.csstransforms) {
      menu4.removeClass("show-nav");
      toggle4.removeClass("show-nav");
      menu4.animate({
        left: "-=300"
      }, 1000);
      toggle4.animate({
        left: "-=-300"
      }, 1000);
    } else {
      menu4.removeClass("show-nav");
      toggle4.removeClass("show-nav");
	  menu.removeClass("show-nav");
	  toggle.removeClass("show-nav");
    }
    
  } else {
    if (!Modernizr.csstransforms) {
      menu4.addClass("show-nav");
      toggle4.addClass("show-nav");
      menu4.css("left", "-330px");
      toggle4.css("left", "-330px");
    } else {
	  
	  //menu.removeClass("show-nav");
	  //toggle.removeClass("show-nav");
      menu4.addClass("show-nav");
      toggle4.addClass("show-nav");
    } 
  }
}
function changeToggleClass() {
  toggleIcon.toggleClass("fa-times");
  toggleIcon.toggleClass("fa-bars");
}
function changeToggleClass2() {
  toggleIcon2.toggleClass("fa-times");
  toggleIcon2.toggleClass("fa-bars");
}
function changeToggleClass3() {
  toggleIcon3.toggleClass("fa-times");
  toggleIcon3.toggleClass("fa-bars");
}
function changeToggleClass4() {
  toggleIcon3.toggleClass("fa-times");
  toggleIcon3.toggleClass("fa-bars");
}
$(document).ready(function() {
  toggle.on("click", function(e) {
	  alert(e);
	  GetProductFeatures($(this).parent());
    e.stopPropagation();
    e.preventDefault();
    toggleThatNav();
    changeToggleClass();
  });
  
toggle2.on("click", function(e) {
	alert(e);
	GetProductFeatures($(this).parent());
    e.stopPropagation();
    e.preventDefault();
    toggleThatNav2();
    changeToggleClass2();
  });
    // Keyboard Esc event support
  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      if (menu.hasClass("show-nav")) {
        if (!Modernizr.csstransforms) {
          menu.removeClass("show-nav");
          toggle.removeClass("show-nav");
          menu.css("left", "300px");
          toggle.css("left", "30px");
          changeToggleClass();
        } else {
          menu.removeClass("show-nav");
          toggle.removeClass("show-nav");
          changeToggleClass();
        }
      }
    } 
  });
  
  $("#back_btn").on("click", function(e) {	
	  if (menu.hasClass("show-nav")) {
	        if (!Modernizr.csstransforms) {
	          menu.removeClass("show-nav");
	          toggle.removeClass("show-nav");
	          menu.css("left", "300px");
	          toggle.css("left", "30px");
	          hideDiv("fabric_sub_menu");
	          changeToggleClass();
	        } else {
	          menu.removeClass("show-nav");
	          toggle.removeClass("show-nav");
	          hideDiv("fabric_sub_menu");
	          changeToggleClass();
	        }
	      } 
  });
   $("#back_btn2").on("click", function(e) {	
	  if (menu2.hasClass("show-nav")) {
	        if (!Modernizr.csstransforms) {
	          menu2.removeClass("show-nav");
	          toggle2.removeClass("show-nav");
	          menu2.css("left", "300px");
	          toggle2.css("left", "30px");
	          hideDiv("fabric_sub_menu");
	          changeToggleClass2();
	        } else {
	          menu2.removeClass("show-nav");
	          toggle2.removeClass("show-nav");
			  //alert($("#pfdd").text().length());
			  if($("#pfdd2 li").hasClass("abc2")||$("#pfdd2 li").hasClass("abc"))
			  {
				menu.addClass("show-nav");
				toggle.addClass("show-nav");
				if($(window).width()>568)
				{
					$("#pfdd2").empty();
					if($("#pfdd li").hasClass("active")){
						$("#pfdd li").removeClass("active");
					}
				}
			  }
	          hideDiv("fabric_sub_menu");
	          changeToggleClass2();
	        }
	      } 
  });
  
  $("#back_btn3").on("click", function(e) {	
	  if (menu3.hasClass("show-nav")) {
	        if (!Modernizr.csstransforms) {
	          menu3.removeClass("show-nav");
	          toggle3.removeClass("show-nav");
	          menu3.css("left", "300px");
	          toggle3.css("left", "30px");
	          hideDiv("fabric_sub_menu");
	          changeToggleClass2();
	        } else {
	          menu3.removeClass("show-nav");
	          toggle3.removeClass("show-nav");
			  //alert($("#pfdd").text().length());
			  if($(window).width()>568)
			  {
				  menu.removeClass("show-nav");
				  menu2.removeClass("show-nav");
				  menu3.removeClass("show-nav");
				  menu4.removeClass("show-nav");
				  $("#pfdd3").empty();
			  }
			  else{
				  if($("#pfdd3 li").hasClass("abc2"))
				  {
					menu2.addClass("show-nav");
					toggle2.addClass("show-nav");
				  }
			  }
	          hideDiv("fabric_sub_menu");
	          changeToggleClass3();
	        }
	      } 
  });
  
  $("#back_btn4").on("click", function(e) {	
	  if (menu4.hasClass("show-nav")) {
	        if (!Modernizr.csstransforms) {
	          menu4.removeClass("show-nav");
	          toggle4.removeClass("show-nav");
	          menu4.css("left", "300px");
	          toggle4.css("left", "30px");
	          hideDiv("fabric_sub_menu");
	          changeToggleClass3();
	        } else {
	          menu4.removeClass("show-nav");
	          toggle4.removeClass("show-nav");
			  //alert($("#pfdd").text().length());
			  if($("#pfdd4 li").hasClass("abc2"))
			  {
				menu3.addClass("show-nav");
				toggle3.addClass("show-nav");
			  }
	          hideDiv("fabric_sub_menu");
	          //changeToggleClass3();
	        }
	      } 
  });
});